import React from "react";

import { IsRunningOverwolf } from "utilityFunctions";
import useApplicationInfo from "hooks/useAppInfo";
import { createPortal } from "react-dom";
import XCircleIcon from "components/XCircleIcon";

type Props = {
  handleClose?: any;
  show: boolean;
  children?: any;
  title?: string;
  customModal?: any;
  large?: boolean;
  width?: string;
  showOverflow?: boolean;
};

export const Modal: React.FC<Props> = ({
  handleClose,
  show,
  children,
  title,
  customModal,
  large,
  showOverflow,
  width,
}) => {
  const showHideClassName = show ? "block" : "hidden";
  const { application } = useApplicationInfo();
  const isRunningIos = application === "IOS_CLIENT";
  const isRunningOverwolf = IsRunningOverwolf();
  const modalContent = (
    <div
      className={`${showHideClassName} relative z-30`}
      aria-labelledby={"modal-title"}
      role={"dialog"}
      aria-modal={true}
      onKeyDown={(e: any) => {
        if (e.key === "Enter") {
          e.stopPropagation();
        }
      }}
    >
      <div className="fixed inset-0 bg-slate-900 bg-opacity-70 z-40"></div>
      <div
        className={`fixed top-0 left-0 right-0 z-50 ${
          showOverflow ? "" : "overflow-y-auto"
        } `}
      >
        <div
          className={`flex min-h-full items-end justify-center p-4 ${
            isRunningOverwolf ? "pt-12" : isRunningIos ? "pt-20 sm:p-0" : ""
          } text-center sm:items-center`}
        >
          {!!customModal ? (
            <div
              className={`relative transform ${
                showOverflow ? "" : "overflow-hidden"
              } rounded-lg shadow-xl transition-all sm:my-8 ${
                large ? "w-3/4" : "sm:w-full sm:max-w-lg xl:max-w-xl w-full"
              }`}
            >
              {customModal}
            </div>
          ) : (
            <div
              className={`relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-8 bg-slate-800 p-2 ${
                width ? width : "w-full sm:max-w-lg"
              }`}
            >
              <div className="w-full flex justify-end absolute -ml-4">
                <button type="button" onClick={handleClose} aria-label="Close">
                  <XCircleIcon className="w-8 h-8 text-slate-400 hover:text-red-500 transition duration-200" />
                </button>
              </div>
              <div className="p-3 lg:p-4">
                <div className="flex items-center justify-center pr-6 sm:pr-0">
                  <h3
                    className="text-xl font-medium leading-6 text-white"
                    id="modal-title"
                  >
                    {title}
                  </h3>
                </div>
                <div className="sm:flex mr-1.5 sm:items-start">{children}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
  return createPortal(modalContent, document.body);
};
